import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useDispatch } from 'react-redux'
import { Col, Modal } from 'reactstrap'
import { toggleLabelOverlay } from 'store/ConfigurationSettings/LanguageConfig/actions'
import { toggleNewLanguageOverlay } from 'store/ConfigurationSettings/LanguageConfig/actions'
import {
  setShowExternalReportsFiltersOverlay,
  setShowGroupsFiltersOverlay,
  setShowCoursesFiltersOverlay,
} from 'store/ManagerReport/actions'
import { toggleEditOverlay } from 'store/Stores/actions'
import { toggleNewStoreOverlay } from 'store/Stores/actions'
import './style.css'

const DefaultModal = (props) => {
  const dispatch = useDispatch()

  const handleCloseModal = (selectedTab) => {
    switch (selectedTab) {
      case 'courses':
        dispatch(setShowCoursesFiltersOverlay(false))
        break
      case 'groups':
        dispatch(setShowGroupsFiltersOverlay(false))
        break
      case 'external-reports':
        dispatch(setShowExternalReportsFiltersOverlay(false))
        break
      case 'newLocation':
        dispatch(toggleNewStoreOverlay())
        break
      case 'addNewLanguage':
        dispatch(toggleNewLanguageOverlay())
        break
      case 'addNewLabel':
        dispatch(toggleLabelOverlay())
        break
      default:
        dispatch(toggleEditOverlay(false))
        break
    }
  }
  return (
    <Modal
      className='modal-dialog-centered'
      isOpen={props.isOpen}
      size={props.size || 'lg'}
      toggle={() => handleCloseModal(props.selectedTab)}
    >
      <div className='modal-header border-bottom pb-2'>
        <h6 className='modal-title text-center'>{props.title}</h6>

        <Col className='text-right' xs='4'>
          <FontAwesomeIcon
            icon={faClose}
            size='lg'
            style={{ cursor: 'pointer' }}
            onClick={() => handleCloseModal(props.selectedTab)}
          />
        </Col>
      </div>
      <div className='modal-body'>{props.children}</div>
    </Modal>
  )
}

export default DefaultModal
